import noUiSlider from 'nouislider';

const RangeSlider = () => {
    const sliderContainer = document.getElementById('slider');

  if (sliderContainer) {
    noUiSlider.create(sliderContainer, {
      start: [0, 1000],
      connect: true,
      range: {
        'min': 0,
        'max': 1000
      },
      tooltips: [true, true],
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return value;
        }
      }
    });
  }
}

export default RangeSlider;
